// extracted by mini-css-extract-plugin
module.exports = {"subtext":"Waypoint_subtext__Zzz_7"};